import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import store from './store'

//import '@/components/globals/_globals'

Vue.config.productionTip = false

/*router.beforeEach((to, from, next) => {
  if (!store.getters['auth/isAuthenticated']) {
    store.dispatch('auth/authenticate').then(() => {
      next()
    }).catch(error => {
      if (!error.message.includes('Could not find stored JWT')) {
        console.log('Authentication error', error)
      }
      (to.meta.requiresAuth) ? next('/login') : next()
    })
  } else {
    next()
  }
})*/

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
